<template>
  <div>
    <pageTable />
  </div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'quality-fabricInspectionReport',
  components: {
    PageTable,
  },
}
</script>
